import React, { useState } from 'react';
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';

// Register chart elements
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const StatisticsChart = ({ graphData }) => {
  if (!graphData.labels.length || !graphData.datasets.length) {
    return <div>No data available</div>; // Display message when no data
}
    const [data, setData] = useState(graphData || {
        labels: [],
          datasets: [
              {
                  label: 'Reviews',
                  data: [], // Replace with your actual data
                  backgroundColor: '#1BC4BD',
                  borderRadius: 6,
                  barThickness: 40,
              },
              {
                  label: 'Listings',
                  data: [], // Replace with your actual data
                  backgroundColor: '#E5EAEE',
                  borderRadius: 6,
                  barThickness: 40,
              },
          ],
      });

    const options = {
        responsive: true,
        legend: {
            display: false,
        },
        scales: {
            x: {
                beginAtZero: true,
            },
            y: {
                beginAtZero: true,
            },
        },
    };

    return (
        <div style={{ width: '100%' }}>
            <Bar data={data} options={options} />
        </div>
    );
};

export default StatisticsChart;
